import { StartBlock } from './common/start-block/StartBlock';

export const CourseCurriculum = () => {
  return (
    <div className={'d-flex justify-content-center align-items-center h-100'}>
      <StartBlock />
    </div>
  );
};
